import * as auth from "../app/modules/Auth/_redux/authRedux";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;
export default function setupAxios(axios) {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  axios.interceptors.request.use(
    (config) => {
      const authToken = localStorage.getItem("tok");
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(null, (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      return Promise.reject(error);
    } else return Promise.reject(error);
  });
}

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  xsrfHeaderName: "X-CSRFToken",
  xsrfCookieName: "csrftoken",
  //headers: { Authorization: "Bearer " + token },
});

export { axiosInstance };
